import React from 'react';
import { SIDE_BAR, SIDE_BAR_GROUP_NAME } from '@localisation/components';
import { SITE_URLS } from '@constants/routes';
import { PermissionCodeConst } from 'skyeye-common-const';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import PeopleIcon from '@material-ui/icons/People';
import BusinessIcon from '@material-ui/icons/Business';
import EventNoteIcon from '@material-ui/icons/EventNote';

export const internalSideBarItems: ISideBarItem[] = [
  // {
  //   label: SIDE_BAR_GROUP_NAME.CAMPAIGN_MANAGEMENT,
  //   icon: <EventNoteIcon />,
  //   subItems: [{
  //     items: [
  //       {
  //         label: SIDE_BAR.CAMPAIGNS,
  //         link: SITE_URLS.CAMPAIGNS,
  //         permission: PermissionCodeConst.CAMPAIGN_EVENT_POST_LIST,
  //       },
  //       {
  //         label: SIDE_BAR.CAMPAIGN_SIGNEES,
  //         link: SITE_URLS.CAMPAIGN_SIGNEES,
  //         permission: PermissionCodeConst.CAMPAIGN_USER_POST_LIST,
  //       },
  //     ]
  //   }],
  // },
  // {
  //   label: SIDE_BAR_GROUP_NAME.SUBSCRIPTIONS,
  //   icon: <CardMembershipIcon />,
  //   subItems: [{
  //     items: [
  //       {
  //         label: SIDE_BAR.SUBSCRIPTION_PLANS,
  //         link: SITE_URLS.SUBSCRIPTION_PLANS,
  //         permission: PermissionCodeConst.SUBSCRIPTION_PLAN_POST_SUBSCRIPTION_PLAN_LIST,
  //       },
  //     ]
  //   }],
  // },
  {
    label: SIDE_BAR_GROUP_NAME.USER_MANAGEMENT,
    icon: <PeopleIcon />,
    subItems: [{
      label: SIDE_BAR.INTERNAL_USERS_MANAGEMENT,
      items: [
        {
          label: SIDE_BAR.INTERNAL_USERS,
          link: SITE_URLS.INTERNAL_USERS,
          permission: PermissionCodeConst.USER_POST_USER_INTERNAL_LIST,
        },
        {
          label: SIDE_BAR.ROLES_SETTINGS,
          link: SITE_URLS.ROLES_SETTINGS,
          permission: PermissionCodeConst.RBAC_POST_ROLE_LIST,
        },
      ]
            
    },
    {
      label: SIDE_BAR.PUBLIC_USERS_MANAGEMENT,
      items: [
        {
          label: SIDE_BAR.PUBLIC_USERS,
          link: SITE_URLS.PUBLIC_USERS,
          permission: PermissionCodeConst.USER_POST_USER_PUBLIC_LIST,
        },
      ]
    }],
  },
  // {
  //   label: SIDE_BAR_GROUP_NAME.ORG_MANAGEMENT,
  //   icon: <BusinessIcon />,
  //   subItems: [{
  //     items: [
  //       {
  //         label: SIDE_BAR.ORGANISATIONS,
  //         link: SITE_URLS.ORG,
  //         permission: PermissionCodeConst.ORGANISATION_POST_ORGANISATION_LIST,
  //       },
  //     ]
  //   }],
  // }
];

export const publicSideBarItems: ISideBarItem[] = [
  {
    label: SIDE_BAR_GROUP_NAME.USER_MANAGEMENT,
    icon: <PeopleIcon />,
    subItems: [{
      items: [
        {
          label: 'Users',
          link: SITE_URLS.ORG_USERS_MANAGEMENT,
          permission: PermissionCodeConst.USER_POST_USER_INTERNAL_LIST,
        },
        {
          label: SIDE_BAR.ROLES_SETTINGS,
          link: SITE_URLS.ROLES_SETTINGS,
          permission: PermissionCodeConst.RBAC_POST_ROLE_LIST,
        },
      ]
            
    }],
  },
];

export interface ISideBarItem {
  label: string,
  icon?: React.ReactNode,
  subItems?: ISideBarSubGroup[]
}

export interface ISideBarSubGroup {
  label?: string,
  items: ISideBarSubItem[],
}

export interface ISideBarSubItem {
  label: string,
  link?: string,
  permission?: string,
}